export const PLACEHOLDER_IMAGE = {
  domain: "placehold.co",
  src: "https://placehold.co/600x400",
  size: "600x400",
};

const MAP_IMAGE_BASE_URL =
  "https://screens-image-components-public.s3.eu-north-1.amazonaws.com";

export const MAP_IMAGE = {
  cityMap2d: `${MAP_IMAGE_BASE_URL}/city-map-2d.png`,
  cityNavigationMap: `${MAP_IMAGE_BASE_URL}/city-navigation-map.png`,
  worldMap2d: `${MAP_IMAGE_BASE_URL}/world-map-2d.png`,
  worldMap3d: `${MAP_IMAGE_BASE_URL}/world-map-3d.png`,
} as const;

export const MAP_IMAGE_URLS: readonly string[] = Object.values(MAP_IMAGE);

export type Photo = {
  photoid: string;
  alt?: string;
  src?: string;
  blurhash?: string;
  width?: number;
  height?: number;
  authorname?: string;
  authorurl?: string;
};

const PHOTO_ATTRIBUTION_PROPS = {
  photoid: "data-photoid",
  authorname: "data-authorname",
  authorurl: "data-authorurl",
  blurhash: "data-blurhash",
} as const;

export const PHOTO_ATTRIBUTION_PROP_NAMES: readonly string[] = Object.values(
  PHOTO_ATTRIBUTION_PROPS,
);

export const photoAttributionProps = (photo: Photo): Record<string, string> =>
  Object.fromEntries(
    Object.entries(PHOTO_ATTRIBUTION_PROPS).flatMap(([field, propName]) => {
      const value = photo[field as keyof typeof PHOTO_ATTRIBUTION_PROPS];
      return value ? [[propName, value]] : [];
    }),
  );

export const getPhotoAttributionProps = (
  props: Record<string, unknown> | undefined,
): Record<string, string> =>
  Object.fromEntries(
    PHOTO_ATTRIBUTION_PROP_NAMES.flatMap((propName) => {
      const value = props?.[propName];
      return typeof value === "string" && value ? [[propName, value]] : [];
    }),
  );

/**
 * Shown when an image's bytes could not be loaded. Inline because this is what
 * a failed request falls back to: fetching it would be one more request to
 * fail, and in a screenshot one the capture would race.
 */
export const MISSING_IMAGE_SRC =
  "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20preserveAspectRatio='none'%3E%3Crect%20width='24'%20height='24'%20fill='%23e5e7eb'/%3E%3Cpath%20d='M3%2017l5-5%203.5%203.5L16%2010l5%206'%20fill='none'%20stroke='%239ca3af'%20stroke-width='1.4'/%3E%3Ccircle%20cx='8.5'%20cy='8'%20r='1.6'%20fill='%239ca3af'/%3E%3C/svg%3E";
